/*
  RYMBU acties (nov 2026): zet automatische kortingen aan en uit op het echte tijdstip.

  Liquid rendert elke actie mee, verborgen (attribuut data-ry-tijd, zie ry-acties.css). Dit
  script kijkt naar de klok van de bezoeker: valt "nu" in een venster, dan krijgt het element
  .ry-actief. Liquid kan dat niet zelf: 'now' is het moment van renderen, en Shopify cachet
  pagina's soms dagen. Zo start en stopt een actie op de minuut, ook op een gecachte pagina.

  Vensters:
    data-ry-vensters="van-tot,van-tot"   unix-seconden, leeg = open (bv. "1790373600-")
    data-ry-dagen="2026-10-14|2026-10-24" JJJJ-MM-DD in lokale tijd, einddag inbegrepen

  Groepen (.ry-actie-groep): enkel de eerste lopende optie blijft aan (de beste korting staat
  eerst). Staat er één aan, dan krijgt de groep .ry-actie-aan en verdwijnt .ry-zonder-actie,
  de gewone prijs.

  Nieuwe HTML (variant wisselen, filters, zoeksuggesties, snel toevoegen) wordt opgepikt via
  een MutationObserver, en elke minuut kijken we opnieuw. Na elke ronde volgt het event
  'ry:acties' op document (de dealspagina telt daarmee haar kaarten).
  Gegevens: snippets/ry-actie.liquid, rymbu-acties\sync_acties.py.
*/
(function () {
  'use strict';

  function dagGrens(tekst, einde) {
    var d = (tekst || '').trim().split('-');
    if (d.length !== 3) return null;
    var t = new Date(+d[0], +d[1] - 1, +d[2] + (einde ? 1 : 0)).getTime();
    return isNaN(t) ? null : t / 1000;
  }

  function actief(el, nu) {
    var vensters = el.getAttribute('data-ry-vensters');
    if (vensters !== null) {
      return vensters.split(',').some(function (venster) {
        var d = venster.split('-');
        var van = parseInt(d[0], 10);
        var tot = parseInt(d[1], 10);
        return (isNaN(van) || nu >= van) && (isNaN(tot) || nu < tot);
      });
    }
    var dagen = el.getAttribute('data-ry-dagen');
    if (dagen !== null) {
      var p = dagen.split('|');
      var start = dagGrens(p[0], false);
      var einde = dagGrens(p[1], true);
      return (start === null || nu >= start) && (einde === null || nu < einde);
    }
    return true;
  }

  function verwerk() {
    var nu = Date.now() / 1000;
    var elementen = document.querySelectorAll('[data-ry-tijd]');
    for (var i = 0; i < elementen.length; i++) {
      elementen[i].classList.toggle('ry-actief', actief(elementen[i], nu));
    }
    var groepen = document.querySelectorAll('.ry-actie-groep');
    for (var j = 0; j < groepen.length; j++) {
      var groep = groepen[j];
      var gekozen = false;
      var opties = groep.querySelectorAll('[data-ry-tijd]');
      for (var k = 0; k < opties.length; k++) {
        var optie = opties[k];
        if (optie.closest('.ry-actie-groep') !== groep || !optie.classList.contains('ry-actief')) continue;
        if (gekozen) optie.classList.remove('ry-actief');
        gekozen = true;
      }
      groep.classList.toggle('ry-actie-aan', gekozen);
    }
    document.dispatchEvent(new CustomEvent('ry:acties'));
  }

  var gepland = false;
  function plan() {
    if (gepland) return;
    gepland = true;
    window.requestAnimationFrame(function () {
      gepland = false;
      verwerk();
    });
  }

  // Enkel reageren op nieuwe elementen met een actie erin; tekst- en klassewijzigingen negeren
  // we, zodat wie op 'ry:acties' de pagina bijwerkt geen lus veroorzaakt.
  var waarnemer = new MutationObserver(function (mutaties) {
    for (var i = 0; i < mutaties.length; i++) {
      var nieuw = mutaties[i].addedNodes;
      for (var j = 0; j < nieuw.length; j++) {
        var n = nieuw[j];
        if (n.nodeType !== 1) continue;
        if (n.matches('[data-ry-tijd], .ry-actie-groep') || n.querySelector('[data-ry-tijd], .ry-actie-groep')) {
          plan();
          return;
        }
      }
    }
  });

  verwerk();
  waarnemer.observe(document.body, { childList: true, subtree: true });
  window.setInterval(verwerk, 60000);
})();
